// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + {"1297":"e30b8d153aa5a1b7","6115":"1dc35e23b7af3845"}[chunkId] + ".css";
};